import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isFetching: false,
  newBuildingInfo: {},
  isSuccess: false,
  success: '',
};

export default function addSystemOrDevice(state = initialState, action) {
  switch (action.type) {
    case actionConstants.ADD_NOTES_REQUEST:
      return {
        ...state,
        isSuccess: false,
        isFetching: true,
        success: '',
      };
    case actionConstants.ADD_NOTES_SUCCESS:
      return {
        ...state,
        newBuildingInfo: action.payload,
        isFetching: false,
        isSuccess: true,
        error: '',
        success: action.message,
      };
    case actionConstants.ADD_NOTES_FAILURE:
      return {
        ...state,
        error: action.message,
        isSuccess: false,
        isFetching: false,
      };
    case actionConstants.RESET_ALL_REDUCERS:
      return {
        ...initialState,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        error: '',
        isSuccess: false,
        isFetching: false,
        success: '',
      };
    default:
      return state;
  }
}
